import store from '../config/store'
import { get_nested_plain } from './miscellaneous'
import reactStringReplace from 'react-string-replace'

export const trans = (key, defaultValue = null) => {
  return get_nested_plain(
    key,
    store.getState()?.data?.translations,
    get_nested_plain(
      key,
      store.getState()?.data?.default_translations,
      defaultValue ? defaultValue : key
    )
  )
}

export const trans_replace = (key, objectReplace) => {
  let line = trans(key)

  if (objectReplace && line) {
    Object.entries(objectReplace).forEach((kv) => {
      line = reactStringReplace(line, kv[0], () => <>{kv[1]}</>)
    })
  }

  return line
}
